import React from "react";

import ModeButton from "./content/ModeButton";
import SearchButton from "./content/SearchButton";
import ServiceMenuButton from "./content/ServiceMenuButton";
import MypageButton from "./content/MypageButton";
import ExitButton from "./content/ExitButton";
import useMemberShip from "store/customHooks/useMemberShip";

function UtilMenu(props) {
    const { isStudyRoom, alertExitApp, gotoServiceMenu, changeMode, gotoSearch, gotoMypage } = props;
    const { ckLTAL, ckLTAL_ALTB, ckALTB } = useMemberShip();
    const LTAL = ckLTAL();
    const LTAL_ALTB = ckLTAL_ALTB();
    const ALTB = ckALTB();

    const isShowSettingButton = !(LTAL || LTAL_ALTB || ALTB); // 설정 버튼 노출 여부

    return (
        <div className="fr gnbMenu2">
            <ModeButton changeMode={changeMode} />
            {!isStudyRoom ? (
                <>
                    {isShowSettingButton && <SearchButton gotoSearch={gotoSearch} />}
                    <ServiceMenuButton gotoServiceMenu={gotoServiceMenu} />
                    <MypageButton gotoMypage={gotoMypage} />
                </>
            ) : (
                <>
                    {isShowSettingButton && <SearchButton gotoSearch={gotoSearch} />}
                    <ServiceMenuButton gotoServiceMenu={gotoServiceMenu} />
                    <ExitButton alertExitApp={alertExitApp} />
                </>
            )}
        </div>
    );
}

export default UtilMenu;
